import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import PageWrapper from "../PageWrapper";
import SubNavbar from "../../components/Navbar/SubNavbar";

import DPTask from "./DPTask";
import MyTask from "./MyTask";
import Detail from "./Detail";
import NewTaskList from "./NewTaskList";
import ButtonBlue from "../../components/Button/ButtonBlue";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

// { title: 'My Task List', url: `${path}/mytask` },
const LearningPages = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const isMyTask =
    useRouteMatch({
      path: `/tasks/mytask`,
      strict: true,
      sensitive: false,
    }) !== null;
  const isNewTask =
    useRouteMatch({
      path: `${path}/new`,
      strict: true,
      sensitive: false,
    }) !== null;
  const isEditTask =
    useRouteMatch({
      path: `${path}/edit/:id`,
      strict: true,
      sensitive: false,
    }) !== null;
  const isMyTaskDetail =
    useRouteMatch({
      path: `${path}/mytask/detail/:id`,
      strict: true,
      sensitive: false,
    }) !== null;
  const isTaskDetail =
    useRouteMatch({
      path: `${path}/detail/:id`,
      strict: true,
      sensitive: false,
    }) !== null;

  return (
    <PageWrapper>
      <div className="cardBackgroundColor border20px shadow-md md:mt-4 md:mb-6  mt-1 mb-3">
        {!isNewTask && !isEditTask && !isTaskDetail && !isMyTaskDetail && (
          <SubNavbar
            menuLinks={[
              { title: "DP Task List", url: path, count: null },
              { title: "My Task List", url: `${path}/mytask`, count: null },
            ]}
            aside={
              isMyTask && (
                <ButtonBlue
                  onClick={() => history.push(`/tasks/new`)}
                  title={"+ Add Task List"}
                />
              )
            }
          />
        )}

        <Switch>
          <Route exact path={path} component={DPTask} />
          <Route path={`${path}/mytask/detail/:id`} component={Detail} />
          <Route path={`${path}/mytask`} component={MyTask} />
          <Route path={`${path}/new`} component={NewTaskList} />
          <Route path={`${path}/edit/:id`} component={NewTaskList} />
          <Route path={`${path}/detail/:id`} component={Detail} />
          <Redirect
            to={{
              pathname: "/page-not-found",
              state: { error: true },
            }}
          />
        </Switch>
      </div>
    </PageWrapper>
  );
};

export default LearningPages;
